<template>
  <w-sliding-popup ref="slidingPopup" type="setting" :title="titleName" @close="closePopup" width="500px">
    <el-form slot="content" :model="urgencyInfo" :rules="rules" label-position="top" ref="urgencyInfoForm">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="ID" prop="urgencyId">
            <el-input :disabled='editField' v-model="urgencyInfo.urgencyId" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="이름" prop="urgencyName">
            <el-input v-model="urgencyInfo.urgencyName" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="설명"  prop="urgencyDesc">
            <el-input v-model="urgencyInfo.urgencyDesc" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" class="mr-r4" type="solid" @click="onClickSave">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import { clone, isUndefined } from 'lodash';
import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
import operationSettingsAPI from '@/api/settings/common/operation-settings';

export default {
  name: 'WUrgencyPopup',
  props: {
    popupType: String,
    editRow: Object,
    urgencyList: Array,
  },
  data() {
    return {
      formName: 'urgencyInfoForm',
      isEdit: false,
      urgencyInfo: {
        urgencyName: null,
        urgencyDesc: null,
        urgencyId: null,
      },
      rules: {
        urgencyId: [{ required: true, trigger: 'blur', validator: this.validateUrgencyId }],
        urgencyName: [{ required: true, trigger: 'blur', validator: this.validateNull, message: '필수 정보입니다.' }],
      },
      dialogVisible: false,
      editField: false,
      titleName: '',
    };
  },
  watch: {
    editRow: {
      handler(row) {
        this.urgencyInfo = clone(row);
        if (this.popupType === 'ADD') {
          this.titleName = '긴급도 추가';
          this.editField = false;
        } else {
          this.titleName = `[${row.urgencyName}] 정보`;
          this.editField = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    onClickSave() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          const params = {
            urgencyName: clone(this.urgencyInfo.urgencyName),
            urgencyDesc: clone(this.urgencyInfo.urgencyDesc),
            urgencyId: clone(this.urgencyInfo.urgencyId),
          };
          if (this.popupType === 'ADD') {
            operationSettingsAPI.insertItsmUrgency(params).then((response) => {
              if (response.data.success) {
                this.$emit('reload-data');
                this.closePopup();
              }
              this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '긴급도', response.data.success));
            });
          } else {
            operationSettingsAPI.updateItsmUrgency(params).then((response) => {
              if (response.data.success) {
                this.$emit('reload-data');
                this.closePopup();
              }
              this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '긴급도', response.data.success));
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('필수사항을 입력해주세요.'));
        }
      });
    },
    validateNull(rule, value, callback) {
      if (isUndefined(value) || value === '') {
        callback(new Error());
      } else {
        callback();
      }
    },
    /**
     * 긴급도도 ID중복 체크
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     * @author jda
     */
    validateUrgencyId(rule, value, callback) {
      if (isEmpty(value)) {
        callback(new Error('아이디를 입력해주세요.'));
      } else if (this.popupType === 'ADD') {
        operationSettingsAPI.existUrgency({ urgencyId: value }).then((response) => {
          if (response.data.success && response.data.data) {
            callback();
          } else {
            callback(new Error('이미 존재하는 아이디입니다.'));
          }
        });
      } else {
        callback();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/popup/UrgencyPopup.vue